import { render, staticRenderFns } from "./PlantBackground.vue?vue&type=template&id=6775425a&scoped=true&"
import script from "./PlantBackground.vue?vue&type=script&lang=ts&"
export * from "./PlantBackground.vue?vue&type=script&lang=ts&"
import style0 from "./PlantBackground.vue?vue&type=style&index=0&id=6775425a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6775425a",
  null
  
)

export default component.exports